















import { Validator } from '@tt4b/ttam-hooks';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';
import QuestionTooltip from 'src/components/common/question-tooltip/index.vue';

const name = 'ttam-instant-message-app-messenger-id';
export default defineComponent({
  name,
  components: {
    QuestionTooltip,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    imaMessengerIdValidate: {
      type: Array as PropType<Validator>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const imaAccountIdRef = ref();
    const _imaAccountId = computed({
      get: () => props.value,
      set: (val: string) => {
        emit('change', val);
        emit('input', val);
      },
    });
    return {
      name,
      imaAccountIdRef,
      _imaAccountId,
    };
  },
});
